import scatterOnClickPopover from "views/components/visualizations/scatter/scatterOnClickPopover";
import sankeyOnClickPopover from "views/components/visualizations/sankey/sankeyOnClickPopover";
const networkOnClickPopover = {
  buildAnchor: scatterOnClickPopover.buildAnchor,
  renderPopover: sankeyOnClickPopover.renderPopover
};
export default networkOnClickPopover;
